//存过敏数据的全部数据列表
import { GET_ALLERGIC_HISTORY_DATA, SET_ALLERGIC_HISTORY_DATA, GET_ALLERGIC_LIST, } from "./actionType";

const defaultState = {
  allergicList: [{ name: "无", id: 0 }],//过敏列表
  allergicHistory: { 213: [], 214: [], 215: [] },//用于编辑的数据
  allergicIndexHistory: { 213: [], 214: [], 215: [] },//展示在首页的数据
};
const Reducer = (state = defaultState, action) => {
  switch (action.type) {
    case GET_ALLERGIC_HISTORY_DATA://存
      const getState = handleAllergicHistory (action.allergicHistory, state);
      return { ...getState };
    case SET_ALLERGIC_HISTORY_DATA://设置
      return { ...state, ...action.params };
    case GET_ALLERGIC_LIST: //存过敏类型
      const newAction = { allergicList: action.allergicList.concat ({ name: "无", id: 0 }) };
      return { ...state, ...newAction };
    default:
      return state;
  }
};

//获取接口数据
const handleAllergicHistory = (action, state) => {
  const newAction = [...action].sort ((a, b) => a.id - b.id);
  const newState = { ...state };
  const obj = {};
  newAction.forEach ((i) => {
    obj[i.id] = i.data.is_operation ? (i.data.is_operation === 1 ? [{
      name: "无", id: 0, values: 0
    }] : [...i.data.list].map (item => ({
      name: item.element_name, id: item.element_id, values: item.values
    }))) : [];
  });
  newState.allergicHistory = obj;
  newState.allergicIndexHistory = obj;
  return newState;
};
export default Reducer;
